import ImageOne from "../thaiunis/AIHM.png";
import ImageTwo from "../thaiunis/AUT.png";
import ImageThree from "../thaiunis/BANGKOK.jpeg";
import ImageFour from "../thaiunis/dusit thani.jpeg";
import ImageFive from "../thaiunis/Rangsit Uni.png";
import ImageSix from "../thaiunis/SIAM.jpeg";
import ImageSeven from "../thaiunis/Silpakorn Uni.png";
import ImageEight from "../thaiunis/STAMFORD.jpeg";
import ImageNine from "../thaiunis/UTCC.png";
import ImageTen from "../thaiunis/VATEL.png";

const universities = [
  // { id: 1,img: ImageOne, name: "", description:"", summary:"", phone:"", email:"", address:"", coursesLink:"", },
  { id: 1, img: ImageOne, name: "ASIAN INSTITUTE OF HOSPITALITY MANAGEMENT" },
  { id: 2, img: ImageTwo, name: "ASSUMPTION UNIVERSITY OF THAILAND" },
  { id: 3, img: ImageThree, name: "BANGKOK UNIVERSITY" },
  { id: 4, img: ImageFour, name: "dusit thani College" },
  { id: 5, img: ImageFive, name: "RANGSIT UNIVERSITY" },
  { id: 6, img: ImageSix, name: "SIAM UNIVERSITY" },
  { id: 7, img: ImageSeven, name: "SILPAKORN UNIVERSITY" },
  { id: 8, img: ImageEight, name: "STAMFORD INTERNATIONAL UNIVERSITY" },
  { id: 9, img: ImageNine, name: "University of the Thai Chamber of Commerce" },
  { id: 10, img: ImageTen, name: "VATEL HOTEL & TOURISM BUSINESS SCHOOL" },
];

export default universities;
